<app-chart-placeholder [loaded]="loaded"></app-chart-placeholder>

<highcharts-chart *ngIf="loaded"
                  [options]="chartOptions"
                  [constructorType]="chartConstructor"
                  style="width: 100%; height: auto; display: block;"
></highcharts-chart>
